import { Component, OnInit } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { getTimeAgo } from 'src/helpers/functions';
import { SharedModule } from '../../../../shared/shared.module';

@Component({
    standalone: true,
    imports: [SharedModule],
  selector: 'app-player-health-renderer',
  templateUrl: './player-health-renderer.component.html',
  styleUrls: ['./player-health-renderer.component.css']
})
export class PlayerHealthRendererComponent implements ICellRendererAngularComp {

  params: any;
  label!: string;

  agInit(params: any): void {
    this.params = params;
    this.label = this.params.label || null;
  }

  refresh(params?: any): boolean {
    this.params = params;
    return true;
  }

  onClick($event: any) {
    if (this.params.onClick instanceof Function) {
      // put anything into params u want pass into parents component
      const params = {
        event: $event,
        rowData: this.params.node.data
        // ...something
      };
      this.params.onClick(params);
    }
  }
    getHealthTooltip(data: any, status: string): string {
    let tooltip = status;
    if (data.displayConfigUpdatedOn) {
      tooltip += `\nUpdated ${getTimeAgo(
        data.displayConfigUpdatedOn
      )} ago`;
    }
    return tooltip;
  }
}
